////////////////////////////////////////////////////////////
//     							                          //
//  Program: MasterHouseRule.jsx                            //
//  Application: Property                                   //
//  Option: to view/add/edit Master House Rule catalog      //
//  Date: 2026-07-09                                        //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { Button, Table, Modal, Form, InputGroup } from "react-bootstrap";

import SimpleReactValidator from "simple-react-validator";
import MasterHouseRuleService from "../../services/MasterHouseRuleService";
import Alerts from "../common/Alerts";
import pluswIcon from "./../../assets/images/plus.svg";
import { Container } from "react-bootstrap";
import NoData from "../common/NoData";

import MasterSidebar from "../common/MasterSidebar";

export class MasterHouseRule extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      open: global.showOpen,
      eventKey: "",
      input: {},
      errors: {},
      status_id: true,
      is_required: true,
      slug: "",

      // for Master House Rule
      addMasterHouseRuleModal: false,
      editMasterHouseRuleModal: false,
      masterHouseRuleList: [],
      masterHouseRuleListTotal: 0,
      rule_text: "",
      checkbox_text: "",
      sort_order: "",
    };
    this.changeHandler = this.changeHandler.bind(this);

    /* for Master House Rule */
    this.openAddMasterHouseRuleModal = this.openAddMasterHouseRuleModal.bind(this);
    this.openEditMasterHouseRuleModal = this.openEditMasterHouseRuleModal.bind(this);
    this.saveMasterHouseRule = this.saveMasterHouseRule.bind(this);
    this.getMasterHouseRuleDetails = this.getMasterHouseRuleDetails.bind(this);
    this.updateMasterHouseRule = this.updateMasterHouseRule.bind(this);
  }

  componentDidMount() {
    this.getMasterHouseRuleData();
  }

  /* to get Master House Rule data */
  async getMasterHouseRuleData() {
    this.setState({ showSpinner: true, loading: true });
    var masterHouseRuleList = [];
    var masterHouseRuleListTotal = 0;

    let res = await MasterHouseRuleService.getMasterHouseRule();

    if (global.successStatus.includes(res.status)) {
      masterHouseRuleList = res.data ? res.data : [];
      masterHouseRuleListTotal = masterHouseRuleList ? masterHouseRuleList.length : 0;
    }
    this.setState({
      masterHouseRuleList: masterHouseRuleList,
      masterHouseRuleListTotal: masterHouseRuleListTotal,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  /* to save Master House Rule data */
  saveMasterHouseRule = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.rule_text &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        rule_text: this.state.rule_text,
        checkbox_text: this.state.checkbox_text,
        is_required: this.state.is_required === true ? 1 : 0,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await MasterHouseRuleService.createMasterHouseRule(inputData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeAddMasterHouseRuleModal();
        this.setState({
          rule_text: "",
          checkbox_text: "",
          is_required: true,
          status_id: true,
          sort_order: "",
        });
        this.getMasterHouseRuleData();
      } else {
        if (res.data.result && res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        } else {
          this.setState({
            showAlertModal: true,
            alertModalType: "error",
            alertModalTitle: "Error!",
            alertModalMessage: res.message ? res.message : "Error!",
          });
        }
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  /* To get Master House Rule details data */
  async getMasterHouseRuleDetails(slug) {
    this.setState({ showSpinner: true, isSubmit: true });
    if (slug) {
      var resData = {};
      let res = await MasterHouseRuleService.getMasterHouseRuleBySlug(slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data ? res.data : {};
        resData.rule_text = res.data.rule_text ? res.data.rule_text : "";
        resData.checkbox_text = res.data.checkbox_text ? res.data.checkbox_text : "";
        resData.sort_order = res.data.sort_order ? res.data.sort_order : "";
        resData.is_required = res.data.is_required === 1 ? true : false;
        resData.status_id = res.data.status_id === 1 ? true : false;
      }
      this.setState(resData);
    }
    this.setState({ showSpinner: false, isSubmit: false });
  }

  /* to update Master House Rule data */
  updateMasterHouseRule = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.rule_text &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        rule_text: this.state.rule_text,
        checkbox_text: this.state.checkbox_text,
        is_required: this.state.is_required === true ? 1 : 0,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await MasterHouseRuleService.updateMasterHouseRule(
        this.state.slug,
        inputData
      );
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeEditMasterHouseRuleModal();
        this.setState({
          rule_text: "",
          checkbox_text: "",
          is_required: true,
          status_id: true,
          sort_order: "",
        });
        this.getMasterHouseRuleData();
      } else {
        if (res.data.result && res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        } else {
          this.setState({
            showAlertModal: true,
            alertModalType: "error",
            alertModalTitle: "Error!",
            alertModalMessage: res.message ? res.message : "Error!",
          });
        }
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  changeHandler = (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
  };

  customValidate() {
    let isValid = true;
    return isValid;
  }

  closeModal() {
    this.setState({ showAlertModal: false });
  }

  /* for Master House Rule modal */
  openAddMasterHouseRuleModal() {
    this.setState({ addMasterHouseRuleModal: true });
  }

  closeAddMasterHouseRuleModal() {
    this.setState({ addMasterHouseRuleModal: false });
    this.setState({
      rule_text: "",
      checkbox_text: "",
      is_required: true,
      sort_order: "",
      status_id: true,
      errors: "",
    });
    this.validator.hideMessages();
  }

  openEditMasterHouseRuleModal(slug) {
    this.getMasterHouseRuleDetails(slug);
    this.setState({ editMasterHouseRuleModal: true });
    this.setState({ slug: slug });
  }

  closeEditMasterHouseRuleModal() {
    this.setState({ editMasterHouseRuleModal: false });
    this.setState({
      slug: "",
      rule_text: "",
      checkbox_text: "",
      is_required: true,
      sort_order: "",
      status_id: true,
      errors: "",
    });
    this.validator.hideMessages();
  }

  setOpen(open, e) {
    this.setState({ open: open });
    this.setState({ eventKey: e.target.id });
    const scrollId = document.getElementById(e.target.id);
    scrollId.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  }

  getTitle() {
    return "Check-in House Rules";
  }

  render() {
    return (
      <>
        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0 pd-lg-l-15 pd-xs-l-0">
                <div className="col-md-2 left">
                  <div className="child-menu-section">
                    <aside>
                      <MasterSidebar />
                    </aside>
                  </div>
                </div>
                <div className="col-md-10 right settingsidebarNav">
                  <div className="col-md-12 mg-t-20 mg-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      <h3>{this.getTitle()}</h3>
                      <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
                        {global.userPermissions.checkPermission("master-data-add") && (
                          <Button
                            variant="outline-dark btn-block btn-with-icon"
                            onClick={this.openAddMasterHouseRuleModal}
                          >
                            <img src={pluswIcon} alt="" /> Add
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="master">
                    <div className="table-responsive">
                      <div className="col-md-12 pl-0 pr-0">
                        <Alerts
                          show={this.state.showAlertModal}
                          type={this.state.alertModalType}
                          title={this.state.alertModalTitle}
                          message={this.state.alertModalMessage}
                        />
                      </div>
                      {this.state.masterHouseRuleListTotal > 0 ? (
                        <Table hover className="mg-b-0">
                          <thead>
                              <tr>
                                  <th width="40%">Check-in House Rules</th>
                                  <th width="5%">&nbsp;</th>
                                  <th width="15%">Checkbox Label</th>
                                  <th width="10%">Required</th>
                                  <th width="10%">Sort Order</th>
                                  <th width="5%">Status</th>
                              </tr>
                          </thead>
                          <tbody>
                            {this.state.masterHouseRuleList.map((item, i) => {
                              return (
                                <tr key={i}>
                                  <td
                                    className="hand-cursor"
                                    onClick={() => {
                                      global.userPermissions.checkPermission(
                                        "master-data-update"
                                      ) && this.openEditMasterHouseRuleModal(item.slug);
                                    }}
                                  >
                                    {item.rule_text}
                                  </td>
                                  <td>&nbsp;</td>
                                  <td>{item.checkbox_text}</td>
                                  <td>{item.is_required === 1 ? "Required" : "Optional"}</td>
                                  <td>{item.sort_order}</td>
                                  <td>
                                    {item.status_id === 1 ? (
                                      <b className="status-active"></b>
                                    ) : (
                                      <b className="status-inactive"></b>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      ) : (
                        <NoData
                          msg={global.commonMessages.checkMessage("MASTERHOUSERULE")}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* add Master House Rule popup modal */}
        <Modal
          show={this.state.addMasterHouseRuleModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeAddMasterHouseRuleModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeAddMasterHouseRuleModal()}
            >
              {global.closee}
            </span>

            <h3 className="text-center">Add Master House Rule</h3>
            <label>Rule Text</label>
            <Form.Control
              as="textarea"
              rows={3}
              onChange={this.changeHandler}
              name="rule_text"
              value={this.state.rule_text}
              className="form-control max_width_100"
              id="inlineFormInput"
              autoComplete="off"
            />
            {this.state.errors.rule_text ? (
              <div className="text-danger">{this.state.errors.rule_text}</div>
            ) : (
              this.validator.message(
                "rule_text",
                this.state.rule_text,
                "required",
                { className: "text-danger" }
              )
            )}

            <label className="mt-3">Checkbox Label</label>
            <Form.Control
              onChange={this.changeHandler}
              name="checkbox_text"
              value={this.state.checkbox_text}
              placeholder="Yes, I agree"
              className="form-control max_width_100"
              id="inlineFormInput"
              type="text"
              autoComplete="off"
            />
            {this.state.errors.checkbox_text && (
              <div className="text-danger">{this.state.errors.checkbox_text}</div>
            )}

            <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "required|numeric|min:0,num",
                { className: "text-danger" }
              )
            )}

            <div className="d-flex align-items-center justify-content-end mt-3">
              Required
              <div
                className={`${this.state.is_required ? "az-toggle az-toggle-required-optional on" : "az-toggle az-toggle-required-optional"} ml-3`}
                onClick={() =>
                  this.setState({ is_required: !this.state.is_required })
                }
              >
                <span></span>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-end mt-3">
              Status
              <div
                className={`${this.state.status_id ? "az-toggle on" : "az-toggle"} ml-3`}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className=" m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeAddMasterHouseRuleModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className=" m-0 btn btn btn-success btn-block"
                onClick={this.saveMasterHouseRule}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* edit Master House Rule popup modal */}
        <Modal
          show={this.state.editMasterHouseRuleModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeEditMasterHouseRuleModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeEditMasterHouseRuleModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Update Master House Rule</h3>
            <label>Rule Text</label>
            <Form.Control
              as="textarea"
              rows={3}
              onChange={this.changeHandler}
              name="rule_text"
              value={this.state.rule_text}
              className="form-control max_width_100"
              id="inlineFormInput"
              autoComplete="off"
            />
            {this.state.errors.rule_text ? (
              <div className="text-danger">{this.state.errors.rule_text}</div>
            ) : (
              this.validator.message(
                "rule_text",
                this.state.rule_text,
                "required",
                { className: "text-danger" }
              )
            )}

            <label className="mt-3">Checkbox Label</label>
            <Form.Control
              onChange={this.changeHandler}
              name="checkbox_text"
              value={this.state.checkbox_text}
              placeholder="Yes, I agree"
              className="form-control max_width_100"
              id="inlineFormInput"
              type="text"
              autoComplete="off"
            />
            {this.state.errors.checkbox_text && (
              <div className="text-danger">{this.state.errors.checkbox_text}</div>
            )}

            <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "required|numeric|min:0,num",
                { className: "text-danger" }
              )
            )}

            <div className="d-flex align-items-center justify-content-end mt-3">
              Required
              <div
                className={`${this.state.is_required ? "az-toggle az-toggle-required-optional on" : "az-toggle az-toggle-required-optional"} ml-3`}
                onClick={() =>
                  this.setState({ is_required: !this.state.is_required })
                }
              >
                <span></span>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-end mt-3">
              Status
              <div
                className={`${this.state.status_id ? "az-toggle on" : "az-toggle"} ml-3`}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                className=" m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeEditMasterHouseRuleModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className=" m-0 btn btn btn-success btn-block"
                onClick={this.updateMasterHouseRule}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default MasterHouseRule;
